import styled from 'styled-components';
import { File } from 'src/components/icons/File';
import { Download } from 'src/components/icons/Download';
import { Button } from 'src/components/common/Button';
import { media } from 'src/styles/designs';
import { useTranslate } from 'react-t7e';
import prettyBytes from 'pretty-bytes';
import { FC } from 'react';
import { Directus_Files } from 'src/graphql/schema.graphql';
import { getPimFileAssetUrl } from 'src/services/pim';

const Container = styled.li`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1rpx solid ${({ theme }) => theme.skeleton.base};
  padding: 16px 0;

  ${media.w.greaterThanOrEqual.desktop} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const FileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${media.w.greaterThanOrEqual.desktop} {
    flex-direction: row;
    align-items: baseline;
    gap: 12px;
  }
`;

const Name = styled.div`
  font-weight: 500;
`;

const Size = styled.div`
  font-size: 13px;
  font-weight: 300;
`;

const StyledButton = styled(Button)`
  min-width: 144px !important;
  max-width: 144px !important;
`;

export const ProductPageDownloadsItem: FC<Directus_Files> = ({
  id,
  filesize,
  filename_download,
}) => {
  const { _ } = useTranslate();

  return (
    <Container>
      <FileContainer>
        <File size={24} />
        <FileDetails>
          <Name>{filename_download}</Name>
          <Size>{prettyBytes(Number(filesize))}</Size>
        </FileDetails>
      </FileContainer>

      <StyledButton
        forwardedAs="a"
        icon={Download}
        href={getPimFileAssetUrl(id) + '?download'}
      >
        {_('DOWNLOAD')}
      </StyledButton>
    </Container>
  );
};
